export default function PrivacyPolicy() {
  return (
    <section
      id="privacy-policy"
      className="relative  z-10 mx-auto flex   max-w-4xl flex-col  gap-5  px-6 py-24 sm:gap-10"
    >
      <div className="flex flex-col items-center  gap-3 ">
        <p className="eyebrow">legal</p>
        <h1 className="text-center text-5xl">Privacy Policy</h1>
        <p className=" text-center text-black/65">Updated Sept. 04, 2026</p>
      </div>

      <article className="space-y-5  text-[#3b3e45]">
        <p className="text-base">
          Kodelle Inc. operates Sakeena. This policy explains what personal
          information we collect, why, who receives it, how long we keep it, and
          your rights over it. It covers the Sakeena app, the sakeena.io
          website, and our waitlist.
        </p>
        <p className="text-base">
          Kodelle Inc. is the controller of this information.
        </p>
        <div className="space-y-2 rounded-2xl bg-[#f0f1f7] px-6 py-5">
          <p>
            <span className="font-semibold">Address:</span> 1536 Day Terr,
            Milton, ON, L9E 1H9, Canada
          </p>
          <p>
            <span className="font-semibold">Contact:</span>{" "}
            <a
              href="mailto:support@sakeena.io"
              target="_blank"
              className="text-[#6e7ce6]"
            >
              support@sakeena.io
            </a>
          </p>
        </div>
        <p className="text-base">
          Sakeena is only for people aged 18 and over.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">1. What we collect</h2>
        <p className="text-base">
          <span className="font-semibold">Account.</span> Email address and
          phone number, both required. We verify both because two independent
          contact points are needed to detect and prevent duplicate and
          fraudulent accounts. Date of birth, to confirm you are 18 or over and
          to show your age. Gender. Where you sign in through Apple or Google,
          the identifier and email address they return to us, which may be a
          relay address.
        </p>
        <p className="text-base">
          Sakeena does not use passwords. You sign in with a one-time code sent
          to your email or by WhatsApp to your phone. We do not hold a password
          for your account.
        </p>
        <p className="text-base">
          <span className="font-semibold">Profile.</span> What you enter under
          About, Basics, Residence, Career, Languages, Faith, Lifestyle, and
          Marriage. This may include your name, height, marital history, whether
          you have children, city and country, residency status, occupation,
          employer, education, income range, languages, sect, religious
          practice, dress, diet, smoking, and your intentions regarding
          marriage.
        </p>

        <div>
          <p className="text-base">
            <span className="font-semibold">Sensitive information.</span> Some
            of the above is a special category of personal data under Article 9
            of the UK and EU General Data Protection Regulation, and sensitive
            personal information under United States state law and Quebec Law
            25:
          </p>
          <div className="mt-3 overflow-x-auto rounded-2xl border border-gray-300">
            <table className="w-full min-w-[36rem] text-left text-base">
              <thead className="bg-[#f0f1f7]">
                <tr>
                  <th className="w-1/3 px-5 py-3 font-semibold">Category</th>
                  <th className="px-5 py-3 font-semibold">What it covers</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-t border-gray-300">
                  <td className="px-5 py-3 align-top font-medium">
                    Religious belief
                  </td>
                  <td className="px-5 py-3 align-top">
                    Sect and your answers under Faith. Your sect determines
                    which pool of profiles you appear in and can see. Sunni and
                    Shia pools are held separately
                  </td>
                </tr>
                <tr className="border-t border-gray-300">
                  <td className="px-5 py-3 align-top font-medium">
                    Racial or ethnic origin
                  </td>
                  <td className="px-5 py-3 align-top">
                    Your ethnicity, which is used as a compatibility criterion
                    in ordering profiles
                  </td>
                </tr>
                <tr className="border-t border-gray-300">
                  <td className="px-5 py-3 align-top font-medium">
                    Biometric information
                  </td>
                  <td className="px-5 py-3 align-top">
                    Facial measurements derived when your photographs are
                    verified. See section 6
                  </td>
                </tr>
                <tr className="border-t border-gray-300">
                  <td className="px-5 py-3 align-top font-medium">
                    Health information
                  </td>
                  <td className="px-5 py-3 align-top">
                    Only where you enter it in a free-text field
                  </td>
                </tr>
                <tr className="border-t border-gray-300">
                  <td className="px-5 py-3 align-top font-medium">
                    Contents of communications
                  </td>
                  <td className="px-5 py-3 align-top">
                    Messages you exchange with another member
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <p className="text-base">
          <span className="font-semibold">Photographs.</span> The photographs
          you upload and versions derived from them, including an obscured
          version where obscuring is available to you.
        </p>
        <p className="text-base">
          <span className="font-semibold">Verification photograph.</span> An
          image of your face captured through your device camera at
          verification. It cannot be selected from your existing photos.
        </p>
        <p className="text-base">
          <span className="font-semibold">Content.</span> Posts you write,
          including answers to guided prompts. Messages you exchange with a
          connected member, which may contain text and images. Reports you
          submit.
        </p>
        <p className="text-base">
          <span className="font-semibold">Vouches.</span> Where someone writes a
          vouch about you, we hold the text, their name, their stated
          relationship to you, and the date. This is information about you that
          we obtain from someone else. Where you write a vouch about another
          person, we collect your name, stated relationship, an email address or
          phone number used to prevent duplicate submissions, the text, and your
          IP address. You do not need an account to write a vouch.
        </p>
        <p className="text-base">
          <span className="font-semibold">Activity.</span> Connection requests
          and their status, active connections, posts liked and saved, profiles
          viewed, preference settings, blocks including the permanent mutual
          block created when a connection is ended, and records of moderation
          decisions affecting your account.
        </p>
        <p className="text-base">
          <span className="font-semibold">Location.</span> We show approximate
          proximity between members. Location is resolved to the centroid of a
          city and shown as a banded label, or as a city or country name at
          greater distances. Where a device reading is used to identify your
          city, that reading is discarded afterwards. We do not store precise
          location.
        </p>
        <p className="text-base">
          <span className="font-semibold">Device and technical.</span> Device
          model, operating system and version, app version, language, push
          notification token, IP address, crash reports, and error diagnostics.
          We also record screens visited, actions taken, and session timing.
        </p>
        <p className="text-base">
          <span className="font-semibold">Advertising identifier.</span> Your
          device advertising identifier and app events such as installs,
          launches, and purchases. On iOS this is only collected where you have
          permitted tracking through the system prompt.
        </p>
        <p className="text-base">
          <span className="font-semibold">Subscriptions.</span> Apple and Google
          handle all payments. We do not receive or store your card number, bank
          details, or billing address. We receive a subscription identifier, the
          plan, dates, and status.
        </p>
        <p className="text-base">
          <span className="font-semibold">Support.</span> Your email address and
          what you write to us.
        </p>
        <p className="text-base">
          <span className="font-semibold">Waitlist.</span> The email address you
          gave and the date you joined.
        </p>
        <p className="text-base">
          <span className="font-semibold">Website.</span> sakeena.io uses
          cookies for session handling and security, and Google Analytics.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">2. Why we use it</h2>
        <div className="overflow-x-auto rounded-2xl border border-gray-300">
          <table className="w-full min-w-[38rem] text-left text-base">
            <thead className="bg-[#f0f1f7]">
              <tr>
                <th className="w-1/2 px-5 py-3 font-semibold">Purpose</th>
                <th className="px-5 py-3 font-semibold">Legal basis</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-t border-gray-300">
                <td className="px-5 py-3 align-top font-medium">
                  Creating and running your account, sending one-time codes
                </td>
                <td className="px-5 py-3 align-top">Contract</td>
              </tr>
              <tr className="border-t border-gray-300">
                <td className="px-5 py-3 align-top font-medium">
                  Verifying your email and phone to detect duplicate and
                  fraudulent accounts
                </td>
                <td className="px-5 py-3 align-top">
                  Legitimate interests in preventing fraud and impersonation
                </td>
              </tr>
              <tr className="border-t border-gray-300">
                <td className="px-5 py-3 align-top font-medium">
                  Confirming you are 18 or over
                </td>
                <td className="px-5 py-3 align-top">
                  Legal obligation, legitimate interests
                </td>
              </tr>
              <tr className="border-t border-gray-300">
                <td className="px-5 py-3 align-top font-medium">
                  Showing your profile, photographs, posts, and vouches to other
                  members
                </td>
                <td className="px-5 py-3 align-top">Contract</td>
              </tr>
              <tr className="border-t border-gray-300">
                <td className="px-5 py-3 align-top font-medium">
                  Holding your sect, to place you in the correct pool
                </td>
                <td className="px-5 py-3 align-top">
                  Explicit consent, Article 9(2)(a). Also Article 9(2)(e), as
                  you publish it on your own profile
                </td>
              </tr>
              <tr className="border-t border-gray-300">
                <td className="px-5 py-3 align-top font-medium">
                  Holding your ethnicity, as a compatibility criterion in
                  ordering profiles
                </td>
                <td className="px-5 py-3 align-top">
                  Explicit consent, Article 9(2)(a). Also Article 9(2)(e)
                </td>
              </tr>
              <tr className="border-t border-gray-300">
                <td className="px-5 py-3 align-top font-medium">
                  Verifying that your photographs are of you
                </td>
                <td className="px-5 py-3 align-top">
                  Substantial public interest in preventing fraud and
                  impersonation, Article 9(2)(g)
                </td>
              </tr>
              <tr className="border-t border-gray-300">
                <td className="px-5 py-3 align-top font-medium">
                  Resolving your city and showing banded proximity
                </td>
                <td className="px-5 py-3 align-top">
                  Consent where a device reading is used, otherwise legitimate
                  interests
                </td>
              </tr>
              <tr className="border-t border-gray-300">
                <td className="px-5 py-3 align-top font-medium">
                  Delivering messages between connected members
                </td>
                <td className="px-5 py-3 align-top">Contract</td>
              </tr>
              <tr className="border-t border-gray-300">
                <td className="px-5 py-3 align-top font-medium">
                  Moderating content, reviewing reports, detecting fraud,
                  enforcing blocks and suspensions
                </td>
                <td className="px-5 py-3 align-top">
                  Legitimate interests, legal obligation, and Article 9(2)(f) or
                  9(2)(g) where sensitive information is involved
                </td>
              </tr>
              <tr className="border-t border-gray-300">
                <td className="px-5 py-3 align-top font-medium">
                  Sending service messages and notifications
                </td>
                <td className="px-5 py-3 align-top">Contract</td>
              </tr>
              <tr className="border-t border-gray-300">
                <td className="px-5 py-3 align-top font-medium">
                  Sending announcements about launch and the service
                </td>
                <td className="px-5 py-3 align-top">
                  Consent, or legitimate interests where permitted
                </td>
              </tr>
              <tr className="border-t border-gray-300">
                <td className="px-5 py-3 align-top font-medium">
                  Diagnosing faults and measuring usage
                </td>
                <td className="px-5 py-3 align-top">Legitimate interests</td>
              </tr>
              <tr className="border-t border-gray-300">
                <td className="px-5 py-3 align-top font-medium">
                  Measuring advertising effectiveness
                </td>
                <td className="px-5 py-3 align-top">
                  Legitimate interests in promoting the service
                </td>
              </tr>
              <tr className="border-t border-gray-300">
                <td className="px-5 py-3 align-top font-medium">
                  Administering subscriptions
                </td>
                <td className="px-5 py-3 align-top">Contract</td>
              </tr>
              <tr className="border-t border-gray-300">
                <td className="px-5 py-3 align-top font-medium">
                  Keeping moderation, enforcement, and transaction records
                </td>
                <td className="px-5 py-3 align-top">
                  Legal obligation, legitimate interests, Article 9(2)(f)
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="text-base">We do not sell personal information.</p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">3. Who receives it</h2>
        <p className="text-base">
          <span className="font-semibold">Other members.</span> Your profile
          fields, photographs, posts, the vouches published about you, and the
          names and stated relationships of the people who wrote them are
          visible to other members. Where you have selective unblur enabled, an
          unobscured photograph is delivered only to a member you have sent a
          request to or accepted a request from. Otherwise no unobscured version
          is delivered to another member's device.
        </p>

        <div>
          <p className="font-semibold">Service providers</p>
          <div className="mt-3 overflow-x-auto rounded-2xl border border-gray-300">
            <table className="w-full min-w-[44rem] text-left text-base">
              <thead className="bg-[#f0f1f7]">
                <tr>
                  <th className="w-1/5 px-5 py-3 font-semibold">Recipient</th>
                  <th className="px-5 py-3 font-semibold">Purpose</th>
                  <th className="px-5 py-3 font-semibold">Location</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-t border-gray-300">
                  <td className="px-5 py-3 align-top font-medium">
                    Amazon Web Services
                  </td>
                  <td className="px-5 py-3 align-top">
                    Hosting, databases, image storage, face comparison, email
                    delivery
                  </td>
                  <td className="px-5 py-3 align-top whitespace-nowrap">
                    United States
                  </td>
                </tr>
                <tr className="border-t border-gray-300">
                  <td className="px-5 py-3 align-top font-medium">Apple</td>
                  <td className="px-5 py-3 align-top">
                    Subscriptions, push notification delivery, sign-in
                  </td>
                  <td className="px-5 py-3 align-top whitespace-nowrap">
                    United States
                  </td>
                </tr>
                <tr className="border-t border-gray-300">
                  <td className="px-5 py-3 align-top font-medium">Google</td>
                  <td className="px-5 py-3 align-top">
                    Subscriptions, push notification delivery, sign-in, app
                    analytics and crash reporting, website analytics
                  </td>
                  <td className="px-5 py-3 align-top whitespace-nowrap">
                    United States
                  </td>
                </tr>
                <tr className="border-t border-gray-300">
                  <td className="px-5 py-3 align-top font-medium">Twilio</td>
                  <td className="px-5 py-3 align-top">
                    Delivery of one-time codes by WhatsApp
                  </td>
                  <td className="px-5 py-3 align-top whitespace-nowrap">
                    United States
                  </td>
                </tr>
                <tr className="border-t border-gray-300">
                  <td className="px-5 py-3 align-top font-medium">
                    Meta Platforms
                  </td>
                  <td className="px-5 py-3 align-top">
                    Delivery of one-time codes over WhatsApp, and advertising
                    measurement
                  </td>
                  <td className="px-5 py-3 align-top whitespace-nowrap">
                    United States
                  </td>
                </tr>
                <tr className="border-t border-gray-300">
                  <td className="px-5 py-3 align-top font-medium">Sentry</td>
                  <td className="px-5 py-3 align-top">
                    Error monitoring, which includes IP address and account
                    identifier
                  </td>
                  <td className="px-5 py-3 align-top whitespace-nowrap">
                    United States
                  </td>
                </tr>
                <tr className="border-t border-gray-300">
                  <td className="px-5 py-3 align-top font-medium">Zendesk</td>
                  <td className="px-5 py-3 align-top">
                    Support ticket management
                  </td>
                  <td className="px-5 py-3 align-top whitespace-nowrap">
                    United States
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <p className="text-base">
          Push notifications include message content in the preview, so Apple
          and Google receive that content in order to deliver the notification.
        </p>
        <p className="text-base">
          We also disclose personal information where required by law or a valid
          order, to establish or defend legal claims, to prevent serious harm,
          and to professional advisers. If Kodelle is party to a merger or sale
          of assets, personal information may transfer, and we will tell you
          beforehand.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">4. International transfers</h2>
        <p className="text-base">
          Our infrastructure is in the United States. Personal information is
          transferred to and processed there. Where we transfer information out
          of the European Economic Area or the United Kingdom, we rely on the
          European Commission's Standard Contractual Clauses and the United
          Kingdom addendum to them. Copies are available from{" "}
          <a
            href="mailto:support@sakeena.io"
            target="_blank"
            className="text-[#6e7ce6]"
          >
            support@sakeena.io
          </a>
          .
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">5. How long we keep it</h2>
        <div className="overflow-x-auto rounded-2xl border border-gray-300">
          <table className="w-full min-w-[38rem] text-left text-base">
            <thead className="bg-[#f0f1f7]">
              <tr>
                <th className="w-1/2 px-5 py-3 font-semibold">Category</th>
                <th className="px-5 py-3 font-semibold">Period</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-t border-gray-300">
                <td className="px-5 py-3 align-top font-medium">
                  Account, profile, photographs, verification photograph, posts,
                  vouches, connections, messages
                </td>
                <td className="px-5 py-3 align-top">
                  For the life of the account
                </td>
              </tr>
              <tr className="border-t border-gray-300">
                <td className="px-5 py-3 align-top font-medium">
                  All personal information, where an account is inactive
                </td>
                <td className="px-5 py-3 align-top">
                  Permanently deleted after three years of inactivity
                </td>
              </tr>
              <tr className="border-t border-gray-300">
                <td className="px-5 py-3 align-top font-medium">
                  Support tickets
                </td>
                <td className="px-5 py-3 align-top">
                  Deleted when the matter is closed
                </td>
              </tr>
              <tr className="border-t border-gray-300">
                <td className="px-5 py-3 align-top font-medium">
                  Error and diagnostic records
                </td>
                <td className="px-5 py-3 align-top">
                  As determined by our error monitoring provider
                </td>
              </tr>
              <tr className="border-t border-gray-300">
                <td className="px-5 py-3 align-top font-medium">
                  Records of financial transactions
                </td>
                <td className="px-5 py-3 align-top">
                  Seven years, to meet tax and accounting requirements
                </td>
              </tr>
              <tr className="border-t border-gray-300">
                <td className="px-5 py-3 align-top font-medium">
                  Moderation, report, and enforcement records
                </td>
                <td className="px-5 py-3 align-top">
                  Retained after closure so that blocks and enforcement remain
                  effective
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">6. Verification of your photographs</h2>
        <p className="text-base">
          To confirm the photographs on a profile are of the account holder, we
          submit your verification photograph and your profile photographs to
          Amazon Rekognition, operated by Amazon Web Services. The service
          returns a similarity score, which determines whether your photographs
          are verified.
        </p>
        <p className="text-base">
          Producing that score requires numerical measurements of facial
          geometry. These are biometric identifiers under the Illinois Biometric
          Information Privacy Act and the Texas Capture or Use of Biometric
          Identifier Act, and biometric data under Article 9 of the General Data
          Protection Regulation. This section is our written retention and
          destruction policy for the purposes of section 15(a) of the Illinois
          Act.
        </p>
        <p className="text-base">
          We retain the verification photograph so that photographs you upload
          later can be checked against it. We do not retain the facial
          measurements, and we do not maintain a face template or a searchable
          collection of faces.
        </p>
        <p className="text-base">
          The verification photograph and any measurements within our control
          are destroyed on the earlier of: deletion of your account, three years
          of inactivity, or three years from your last interaction with us.
        </p>
        <p className="text-base">
          We do not sell, lease, trade, or otherwise profit from biometric
          information. We do not disclose it to anyone other than Amazon Web
          Services, except where compelled by a valid legal order. Your
          verification photograph is never shown to another member.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">7. Deleting your account</h2>
        <p className="text-base">
          You can delete your account in the app. Your profile is hidden from
          all members immediately and your information is permanently deleted 90
          days later. If you sign in within those 90 days, your account is
          restored.
        </p>
        <p className="text-base">
          If you hold a subscription, you must cancel it with Apple or Google
          before deleting your account. We cannot cancel it for you.
        </p>
        <p className="text-base">
          If you write to{" "}
          <a
            href="mailto:support@sakeena.io"
            target="_blank"
            className="text-[#6e7ce6]"
          >
            support@sakeena.io
          </a>{" "}
          asking us to erase your information, we will do so within one month
          rather than through the 90 day process.
        </p>
        <p className="text-base">
          After deletion we retain only records of financial transactions we are
          required to keep, and the records needed to keep blocks and
          enforcement decisions effective.
        </p>
        <p className="text-base">
          Backups are taken daily and overwritten on a rolling basis. Deleted
          information may persist in a backup until that cycle completes.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">8. Your rights</h2>
        <p className="text-base">
          You can ask us to confirm what we hold about you, give you a copy,
          correct it, delete it, restrict how we use it, withdraw a consent you
          gave, and stop sending you marketing email.
        </p>
        <p className="text-base">
          <span className="font-semibold">
            United Kingdom and European Economic Area.
          </span>{" "}
          You hold the rights in Chapter III of the General Data Protection
          Regulation, including the right to object to processing based on
          legitimate interests. You may complain to your supervisory authority.
          In the United Kingdom this is the Information Commissioner's Office.
        </p>
        <p className="text-base">
          <span className="font-semibold">Canada.</span> You hold rights of
          access and correction under the Personal Information Protection and
          Electronic Documents Act, and may complain to the Office of the
          Privacy Commissioner of Canada.
        </p>
        <p className="text-base">
          <span className="font-semibold">Quebec.</span> You additionally hold
          rights of portability, to be informed of decisions made about you by
          automated means, and to require that we stop disseminating your
          information. You may complain to the Commission d'accès à
          l'information du Québec.
        </p>
        <p className="text-base">
          <span className="font-semibold">United States.</span> Where your
          state's law gives you rights of access, correction, deletion,
          portability, or to limit the use of sensitive personal information,
          you hold them. We do not sell personal information. We use sensitive
          personal information only to provide the service, maintain quality and
          safety, and prevent fraud, and not to infer characteristics about you.
        </p>
        <p className="text-base">
          <span className="font-semibold">
            Illinois, Texas, and Washington.
          </span>{" "}
          Section 6 sets out our retention and destruction schedule for
          biometric information.
        </p>
        <p className="text-base">
          To exercise a right, write to{" "}
          <a
            href="mailto:support@sakeena.io"
            target="_blank"
            className="text-[#6e7ce6]"
          >
            support@sakeena.io
          </a>
          . We respond within 30 days, or sooner where your local law requires.
          We may need to verify your identity and will ask only for what is
          necessary.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">9. Automated processing</h2>
        <p className="text-base">
          Photographs are verified by an automated comparison. Where
          verification does not succeed you may try again and may ask us to
          review it.
        </p>
        <p className="text-base">
          Content and reports are moderated using automated checks. Where this
          results in a restriction on your account, you may ask us to review it
          and a person will do so.
        </p>
        <p className="text-base">
          Preferences you set are ranking inputs. They affect the order in which
          profiles and posts appear. They do not hide any member from you, and
          they do not hide you from anyone.
        </p>
        <p className="text-base">
          None of this produces a legal effect concerning you within the meaning
          of Article 22 of the General Data Protection Regulation, and human
          review is available in each case.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">10. Security</h2>
        <p className="text-base">
          Information is encrypted in transit and at rest. Verification
          photographs are stored separately from profile photographs and are not
          publicly accessible or served through a content delivery network.
          Access to message content is granted selectively to administrators on
          a need to know basis, and only where necessary to investigate a
          report, respond to a legal request, or address a safety concern.
        </p>
        <p className="text-base">
          Sakeena applies technical measures on iOS and Android intended to
          prevent screen capture of profiles and photographs. These raise the
          effort required to capture what you share. They do not make it
          impossible.
        </p>
        <p className="text-base">
          No system is entirely secure. Where a breach affects your personal
          information we will notify you and the relevant regulators as the law
          requires.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">11. Age and child safety</h2>
        <p className="text-base">
          Sakeena is only for people aged 18 and over. We do not knowingly
          collect information from anyone under 18, and we close any account we
          find to be held by a minor and delete the information.
        </p>
        <p className="text-base">
          We prohibit child sexual abuse and exploitation and any content or
          conduct relating to it. We remove such content, terminate the accounts
          responsible, and report to law enforcement and child protection
          authorities as required under Canadian and Ontario law. Report
          anything of this kind to{" "}
          <a
            href="mailto:support@sakeena.io"
            target="_blank"
            className="text-[#6e7ce6]"
          >
            support@sakeena.io
          </a>
          , and to the Canadian Centre for Child Protection at{" "}
          <a
            href="https://cybertip.ca"
            target="_blank"
            className="text-[#6e7ce6]"
          >
            cybertip.ca
          </a>
          .
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">12. Changes</h2>
        <p className="text-base">
          We may update this policy. Where a change is material, and in
          particular where it affects sensitive information or what other
          members can see, we will tell you before it takes effect and, where
          consent is the basis, ask again. The date at the top is the date of
          the current version.
        </p>
      </article>

      <hr className=" text-gray-300" />

      <article className="space-y-5  text-[#3b3e45]">
        <h2 className=" text-3xl">13. Contact</h2>
        <div className="space-y-2 rounded-2xl bg-[#f0f1f7] px-6 py-5">
          <p className="font-semibold">Kodelle Inc.</p>
          <p>
            Email:{" "}
            <a
              href="mailto:support@sakeena.io"
              target="_blank"
              className="text-[#6e7ce6]"
            >
              support@sakeena.io
            </a>
          </p>
          <p>Address: 1536 Day Terr, Milton, ON, L9E 1H9, Canada</p>
          <p>
            Website:{" "}
            <a
              href="https://sakeena.io"
              target="_blank"
              className="text-[#6e7ce6]"
            >
              https://sakeena.io
            </a>
          </p>
        </div>
      </article>

      <hr className=" text-gray-300" />
    </section>
  );
}
